import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es realmente discreto?',
  a: 'Absolutamente. El manual llega a tu email con un nombre genérico en el asunto. Los ejercicios se pueden hacer en la privacidad de tu habitación, sin equipo, sin ruido. Nadie sabrá qué estás haciendo.'
}, {
  q: '¿Funciona si tengo más de 60 años?',
  a: 'Sí. De hecho, muchos de nuestros usuarios tienen entre 55-65 años. La edad no es el problema; la inactividad del endotelio lo es. Y eso se puede revertir a cualquier edad.'
}, {
  q: '¿Necesito comprar algo adicional?',
  a: 'No. El protocolo usa solo tu cuerpo y respiración. Los alimentos que recomendamos son opcionales (pero altamente efectivos).'
}, {
  q: '¿Qué pasa si no funciona para mí?',
  a: 'Ofrecemos garantía de 30 días. Si sigues el protocolo al pie de la letra y no ves resultados, te devolvemos cada centavo. Sin preguntas.'
}, {
  q: '¿Es seguro si tomo medicamentos para el corazón?',
  a: 'El protocolo es 100% natural y no invasivo. Sin embargo, si tienes condiciones cardíacas diagnosticadas, consulta con tu médico antes de comenzar cualquier nuevo protocolo de ejercicios.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-81">
            Resolvamos Tus Últimas Dudas
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-82"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden" data-id="element-84">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-85">
                <span className="font-semibold text-lg text-slate-200" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-blue-500 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>
              <AnimatePresence data-id="element-88">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-slate-400 leading-relaxed" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}